import React from 'react';
import { DropdownMenu } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/components/DropdownMenu';
import PortfolioBuilderStore, {
  adStrategies
} from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/PortfolioBuilder/stores';
import { styled } from '@mui/system';
import { AD_AUTOMATION_TYPE_EDIT_DISABLED } from 'src/utils/app';

export const OptimizationDropdown = () => {
  const { selectedOptimizationId, setSelectedOptimizationId } = PortfolioBuilderStore((s) => ({
    setSelectedOptimizationId: s.setSelectedOptimizationId,
    selectedOptimizationId: s.selectedOptimizationId
  }));

  const StyledDiv = styled('div')({
    '& .MuiTypography-root': {
      fontWeight: 400,
      fontiSize: '14px'
    }
  });

  if (AD_AUTOMATION_TYPE_EDIT_DISABLED) {
    const selectedStrategy = adStrategies.find((strategy) => strategy.id === selectedOptimizationId);
    return <StyledDiv style={{ width: 'fit-content', marginBottom: '24px' }}>{selectedStrategy?.label}</StyledDiv>;
  }

  return (
    <StyledDiv style={{ width: 'fit-content', marginBottom: '24px' }}>
      <DropdownMenu
        options={adStrategies}
        selectedId={selectedOptimizationId}
        onChange={(strategy) => {
          setSelectedOptimizationId(strategy.id);
        }}
      />
    </StyledDiv>
  );
};
